import ButtonCinestar from 'components/Buttons/ButtonCinestar/ButtonCinestar'
import Typography from 'components/Typography/Typography'
import { useIntl } from 'react-intl'
import './../Modal.scss'

export default function ModalWarning({
    titleTextId,
    descriptionTextId,
    firstBtnTextId,
    firstBtnClick,
    secondBtnTextId,
    secondBtnClick,
}) {
    const intl = useIntl()
    return (
        <div className="modal-message">
            <div className="window">
                <div className="title-section">
                    <Typography variant={'h1'}>{intl.formatMessage({ id: titleTextId })}</Typography>
                </div>
                <Typography variant={'p'}>{intl.formatMessage({ id: descriptionTextId })}</Typography>
                <div className="buttons-section">
                    <ButtonCinestar onClick={firstBtnClick} variant={'primary-v1'}>
                        {intl.formatMessage({ id: firstBtnTextId })}
                    </ButtonCinestar>
                    <ButtonCinestar onClick={secondBtnClick} variant={'primary-v1'}>
                        {intl.formatMessage({ id: secondBtnTextId })}
                    </ButtonCinestar>
                </div>
            </div>
        </div>
    )
}
